<template>
    <div>
        <rkm-area
            type="fieldset"
            title="Filtros"
        >
            <rkm-form ref="Form">
                <rkm-row class="flex-nowrap">
                    <rkm-col cols="3">
                        <rkm-form-date-picker
                            :range-inline="false"
                            label="Data"
                            v-model="model.dataSaida"
                            :validations="validations.dataSaida"
                        />
                    </rkm-col>

                    <rkm-col cols="4">
                        <rkm-form-select
                            :options="municipios"
                            label="Município"
                            show-default-option
                            text-field="nome"
                            v-model="model.municipioId"
                            value-field="id"
                            :validations="validations.municipio"
                            :default-option-text="municipios.length === 0 ? 'Nenhum município para a data' : 'Selecione'"
                            :disabled="municipios.length === 0"
                            @change="loadFields('municipioId')"
                        />
                    </rkm-col>

                    <rkm-col class="flex-grow-1">
                        <rkm-form-select
                            :options="destinos"
                            label="Local da consulta"
                            show-default-option
                            text-field="descricao"
                            v-model="model.destinoId"
                            value-field="id"
                            default-option-text="Todos"
                            :disabled="!model.municipioId"
                            @change="loadFields('destinoId')"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row class="flex-nowrap">

                    <rkm-col cols="3">
                        <rkm-form-select
                            :options="horariosSaida"
                            label="Horário Saída"
                            show-default-option
                            text-field="horarioSaida"
                            v-model="model.horarioSaida"
                            value-field="horarioSaida"
                            default-option-text="Todos"
                        />
                    </rkm-col>

                    <rkm-col cols="4">
                        <rkm-form-select
                            :options="tiposPassageiro"
                            label="Tipo de passageiro"
                            show-default-option
                            text-field="descricao"
                            v-model="model.tipoPassageiroId"
                            value-field="id"
                            default-option-text="Todos"
                        />
                    </rkm-col>

                    <rkm-col class="flex-grow-1">
                        <rkm-form-select
                            :options="ordenacao"
                            label="Ordenação"
                            text-field="text"
                            v-model="selected"
                            value-field="value"
                        />
                    </rkm-col>

                    <rkm-col cols="auto">
                        <rkm-button
                            :label="false"
                            color="primary"
                            @click="$refs.Form.validate(search)"
                        >
                            Buscar
                        </rkm-button>

                        <rkm-button
                            :label="false"
                            @click="resetForm()"
                        >
                            Limpar
                        </rkm-button>
                    </rkm-col>
                </rkm-row>
            </rkm-form>
        </rkm-area>

        <rkm-area
            v-if="isSearch && items.length > 0"
            title="ATRIBUIR PARA OS AGENDAMENTOS SELECIONADOS"
            type="fieldset"
            no-margin-top
        >

            <rkm-form ref="FormAtribuir">
                <rkm-row class="flex-nowrap">

                    <rkm-col cols="4">
                        <rkm-form-select
                            :options="veiculos"
                            text-field="descricao"
                            value-field="id"
                            label="Veículo"
                            v-model="model.veiculoId"
                            :validations="validations.veiculo"
                            show-default-option
                            @change="handleVeiculo()"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <rkm-form-select
                            :options="jornadas"
                            text-field="descricao"
                            value-field="id"
                            label="Jornada"
                            v-model="model.jornadaId"
                            :validations="form.agendarTransporteJornada && model.veiculoId ? validations.jornada : {}"
                            show-default-option
                            @change="handleJornada()"
                        />
                    </rkm-col>

                    <rkm-col class="flex-grow-1">
                        <rkm-form-input
                            label="Agendados"
                            type="number"
                            v-model="getTotalAgendados"
                            disabled
                        />
                    </rkm-col>

                    <rkm-col class="flex-grow-1">
                        <rkm-form-input
                            label="Capacidade"
                            type="number"
                            v-model="model.capacidade"
                            disabled
                        />
                    </rkm-col>

                    <rkm-col class="flex-grow-1">
                        <rkm-form-select
                            :options="form.tiposVeiculo"
                            text-field="descricao"
                            value-field="id"
                            label="Tipo de veículo"
                            v-model="model.tipoVeiculoId"
                            show-default-option
                            disabled
                        />
                    </rkm-col>

                </rkm-row>

                <rkm-row class="flex-nowrap">

                    <rkm-col cols="3">
                        <rkm-form-input
                            label="Passageiros selecionados"
                            type="number"
                            v-model="getTotalSelecionado"
                            disabled
                        />
                    </rkm-col>

                    <rkm-col cols="2">
                        <rkm-form-input
                            label="Vagas disponíveis"
                            type="number"
                            v-model="getVagasDisponiveis"
                            disabled
                        />
                    </rkm-col>

                    <rkm-col cols="auto">

                        <rkm-button
                            :label="false"
                            @click="$refs.FormAtribuir.validate(atribuir)"
                            color="primary"
                            :disabled="handleDisabledAtribuir"
                        >
                            Atribuir
                        </rkm-button>

                        <rkm-button
                            :label="false"
                            @click.stop="resetAtribuir"
                            color="secondary"
                            :disabled="!model.veiculoId"
                        >
                            Limpar
                        </rkm-button>
                    </rkm-col>
                </rkm-row>
            </rkm-form>
        </rkm-area>

        <rkm-row v-if="isSearch && items.length > 0">
            <rkm-col>
                <rkm-button
                    @click="selecionarTodos()"
                    color="primary"
                    class="mb-2"
                >
                    <template v-if="selecionados == false">
                        Selecionar todos
                    </template>

                    <template v-else>
                        Desmarcar selecionado(s)
                    </template>
                </rkm-button>

                <template>
                    <rkm-button
                        v-if="selecionados == true"
                        @click="cancelAtribuirSelecionados()"
                        :disabled="handleDisabledAtribuidos"
                        color="danger"
                        class="mb-2"
                    >
                        Cancelar atruibuição dos selecionado(s)
                    </rkm-button>
                </template>
            </rkm-col>
        </rkm-row>

        <rkm-form
            ref="Table"
        >
        <div
            v-for="(item, index) in items"
            class="mb-3"
            :key="index"
        >

            <rkm-table
                v-if="isSearch"
                :items="[item]"
                :fields="fields"
                hide-filters
                hide-pagination
                sort-by="nome"
                :tbody-tr-class="rowClass"
            >

                <template #thead-top>

                    <rkm-tr>

                        <rkm-th class="table-width-60" colspan="4">
                            <div class="table-width-50 float-left" >
                                Paciente: {{ item.pacienteNome }}
                                <span v-if="item.pacientePreferenciaNome">
                                    <strong>({{ item.pacienteNomeSocial }})</strong>
                                </span>
                            </div>
                        </rkm-th>

                        <rkm-th colspan="2">
                            Prontuário: {{ item.pacienteProntuario }}
                        </rkm-th>

                        <rkm-th class="table-width-30" colspan="2">
                            Idade: {{ item.pacienteIdade }}
                        </rkm-th>

                        <rkm-th class="table-width-30" colspan="3">
                            Data de nascimento: {{ item.pacienteNascimento }}
                        </rkm-th>
                    </rkm-tr>
                </template>

                <template v-slot:cell(checkbox)="{ item }">
                    <rkm-form-checkbox
                        v-model="item.selecionado"
                        @change="handleBlur()"
                        :disabled="item.veiculoId && item.veiculoId == model.veiculoId"
                    />
                </template>

                <template v-slot:cell(horarioSaida)="{ item }">
                    <rkm-form-time-picker
                        name="Horário saída"
                        v-model="item.horarioSaida"
                        :validations="validationsHorarioSaida(item)"
                        class="dataSaida mb-0"
                    />
                </template>

                <template v-slot:cell(dataConsulta)="{ item }">
                    {{ item.dataConsulta }} - {{ item.horarioConsulta }}
                </template>

                <template v-slot:cell(actions)="{ item }">
                    <rkm-button
                        :color="item.consultaObservacao ? 'info' : 'secondary'"
                        small
                        v-rkm-popover.hover.left="{
                            title:'Observação',
                            html:true,
                            content: item.consultaObservacao
                                ? item.consultaObservacao
                                : 'Nenhuma observação informada.',
                        }"
                    >
                        <i class="fas fa-comment-alt"></i>
                    </rkm-button>

                    <rkm-button
                        title="Cancelar atribuição"
                        color="danger"
                        :disabled="!item.veiculoId"
                        @click="cancelAtribuir(item)"
                        small
                    >
                        <rkm-icon icon="trash" />
                    </rkm-button>
                </template>
            </rkm-table>

        </div>
        </rkm-form>

        <div class="table-td text-right" v-if="isSearch && items.length > 0">
            Total de passageiros: {{ getTotal() }}
        </div>

        <ModalPermissao
            ref="RkmModalPermissao"
            @handlePermission="handlePermission"
        />

        <ModalListaAgendamento ref="ModalListaAgendamento" />

        <rkm-table
            v-if="isSearch && items.length === 0"
            :items="items"
            :fields="fields"
            hide-filters
            hide-pagination
            sort-by="nome"
        />
    </div>
</template>

<script>

// Vuex.
import { mapActions } from 'vuex'

// Mixins.
import { error, repository, object, data, stringCase} from '@/mixins'

// Filters.
import format from '@/filters/formats'

// Moment.
import moment from 'moment'

// Enums.
import preferenciaNome from '@/enums/cadastro/cidadao/preferenciaNome'
import tipoPassageiro from '@/enums/transporte-paciente/tipoPassageiro'

// Components.
import ModalPermissao from '@/components/transporte-paciente/escolher/permissao/Modal'
import ModalListaAgendamento from '@/components/transporte-paciente/escolher/components/agendamento/Modal'

export default {
    components: {
        ModalPermissao,
        ModalListaAgendamento,
    },
    computed: {
        validations() {

            return {
                dataSaida: { required: true },
                municipio: { required: true },
                veiculo: { required: true },
                jornada: { required: true },
            }
        },
        validationsHorarioSaida() {

            return (item) => {
                return {
                    max_hour: item.dataConsulta === item.dataSaida ? this.getMaxHour(item) : false,
                    required: item.veiculoId ? true : false
                };
            };
        },
        getTotalSelecionado() {

            return this.items.filter(item => item.selecionado)
                .reduce((sum, element) => {

                    if (element.veiculoId) {

                        if (element.veiculoId !== this.model.veiculoId) {

                            if (element.acompanhante !== 'NÃO') {

                                sum = sum + (Number(element.acompanhante) + 1);
                            } else {

                                sum++;
                            }
                        }
                    } else {

                        if (element.acompanhante !== 'NÃO') {

                            sum = sum + (Number(element.acompanhante) + 1);
                        } else {

                            sum++;
                        }
                    }

                    return sum;
                },0)
        },
        getTotalAgendados() {

            const total = this.model.totalAgendados

            const atribuidos = this.items.filter(item => item.veiculoId === this.model.veiculoId)
                .reduce((sum, element) => {

                    if (element.acompanhante !== 'NÃO') {

                        sum = sum + (Number(element.acompanhante) + 1);
                    } else {

                        sum++;
                    }

                    return sum;
                },0)

            return this.model.veiculoId && atribuidos > 0 ? Number(total) + Number(atribuidos) : total
        },
        getVagasDisponiveis() {

            const vagas = this.model.capacidade - this.getTotalAgendados >= 0
                ? this.model.capacidade - this.getTotalAgendados
                : 0

            return this.model.veiculoId ? vagas : null
        },
        handleDisabledAtribuidos() {

            const atribuidos = this.items.filter(item => item.selecionado && item.veiculoId)

            return atribuidos.length === 0 ? true : false
        },
        handleDisabledAtribuir() {

            const atribuidos = this.items.filter(item => item.selecionado && !item.veiculoId
                || item.selecionado && item.veiculoId && item.veiculoId !== this.model.veiculoId)

            return atribuidos.length === 0 ? true : false
        },
        fields() {
            return [
                {
                    key: 'checkbox',
                    label: '#',
                    class: 'col-min text-center',
                },
                {
                    key: 'municipio',
                    label: 'Município',
                    searchable: true,
                },
                {
                    key: 'destino',
                    label: 'Local da consulta',
                    searchable: true,
                },
                {
                    key: 'ponto',
                    label: 'Ponto de referência',
                    searchable: true,
                },
                {
                    key: 'horarioSaida',
                    label: 'Horário saída',
                    class: 'col-min text-center',
                    searchable: true,
                },
                {
                    key: 'dataConsulta',
                    label: 'Data consulta',
                    searchable: true,
                    class: 'col-min text-center',
                },
                {
                    key: 'acompanhante',
                    label: 'Acompanhante',
                    searchable: true,
                    class: 'col-min text-center',
                },
                {
                    key: 'veiculoNome',
                    label: 'Veículo',
                    searchable: true,
                },
                {
                    key: 'profissionalNome',
                    label: 'Agendador',
                    searchable: true,
                },
                {
                    key: 'tipoPassageiroDescricao',
                    label: 'Tipo de passageiro',
                    searchable: true,
                },
                {
                    key: 'actions',
                    label: 'Ações',
                    class: 'col-min text-center'
                }
            ];
        },
    },
    created() {

        this.repositories = {
            escolher: this.getConectaSusRepository('transportePaciente.escolher'),
            agendar: this.getConectaSusRepository('transportePaciente.agendar')
        }

        this.load()
    },
    data: () => ({
        form: [],
        items: [],
        filterDefault: {},
        selected: "data_consulta",
        model: {
            dataSaida: null,
            municipioId: null,
            destinoId: null,
            horarioSaida: null,
            veiculoId: null,
            capacidade: null,
            totalAgendados: null,
            tipoVeiculoId: null,
            tipoPassageiroId: null,
            supervisorId: null,
            ordenacao: null,
        },
        municipios: [],
        destinos: [],
        jornadas: [],
        ordenacao: [],
        agendamentosJornada: [],
        horariosSaida: [],
        veiculos: [],
        tiposPassageiro: [],
        fieldMap: [
            'data',
            'municipioId',
            'destinoId',
            'horarioSaida',
        ],
        isSearch: false,
        selecionados: false,
        enums: {
            preferenciaNome,
            tipoPassageiro,
        }
    }),
    filters: {
        ...format,
    },
    methods: {
        ...mapActions(['setLoading', 'unsetLoading', 'unsetShowExitFormConfirmation']),
        load() {

            this.setLoading()

            this.repositories.escolher.create()
                .then(({ data }) => {

                    this.form = data.form
                    this.model = data.model

                    this.filterDefault = {
                        form: this.clone(this.form),
                        model: this.clone(this.model)
                    }

                    this.municipios = data.form.municipios
                    this.destinos = data.form.destinos
                    this.tiposPassageiro = data.form.tiposPassageiro
                    this.horariosSaida = data.form.horariosSaida
                    this.jornadas = data.form.jornadas
                    this.ordenacao = data.form.ordenacao

                    this.setDefaultValues()
                    this.addWatchers()
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        loadFields(field) {

            this.setLoading()

            this.setFields(field)

            this.repositories.escolher.loadFields(this.getSearchParams())
                .then(({ data }) => {

                    this.municipios = data.form.municipios
                    this.destinos = data.form.destinos
                    this.horariosSaida = data.form.horariosSaida
                    this.tiposPassageiro = data.form.tiposPassageiro
                    this.jornadas = data.form.jornadas
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        getSearchParams() {

            this.model.ordenacao = this.selected

            const params = this.clone(this.model)

            this.formateDates(params, ['dataSaida'], 'YYYY-MM-DD')

            return this.camelObjectKeysToSnakeRecursive(params)
        },
        addWatchers() {

            this.$watch('model.dataSaida', function (data) {

                if (data) {

                    this.loadFields('data')
                }
            })
        },
        setFields(value) {

            this.isSearch = false

            const index = this.fieldMap.indexOf(value) + 1;

            for (let i = index; i < this.fieldMap.length; i++) {

                const field = this.fieldMap[i];

                if (this.model[field] !== null) {

                    for (const ref of Object.values(this.$refs)) {

                        if (ref.validate) {
                            ref.resetValidator();
                        }
                    }

                    this.$set(this.model, field, null);
                }
            }
        },
        resetForm() {

            this.form = this.clone(this.filterDefault.form)
            this.model = this.clone(this.filterDefault.model)
            this.isSearch = false
            this.selecionados = false
            this.items = []

            this.setDefaultValues()

            if (this.$refs.Form) {

                this.$refs.Form.resetValidator()
            }
        },
        setDefaultValues() {

            this.model.dataSaida = moment(this.form.dataAtual, 'DD/MM/YYYY').toDate()
        },
        search() {

            this.setLoading()

            this.repositories.escolher.list(this.getSearchParams())
                .then(({ data }) => {

                    this.items = data.agendamentos
                    this.agendamentosJornada = data.agendamentosJornada
                    this.veiculos = data.veiculos
                    this.jornadas = data.jornadas
                    this.isSearch = true
                    this.selecionados = false

                    this.model.veiculoId = null
                    this.resetAtribuir()
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        getMaxHour(item) {

            const horario = item.horarioConsulta

            if (horario) {

                return moment(horario, 'HH:mm').subtract(1, 'minutes').format('HH:mm')
            }

            return false
        },
        selecionarTodos(){

            if(this.selecionados == false){

                this.selecionados = true
                this.items.map(item => (item.selecionado = true))
            } else {

                this.selecionados = false
                this.items.map(item => (item.selecionado = false))
            }
        },
        showVeiculo() {

            return this.form.agendarTransporteJornada && this.model.jornadaId
                || !this.form.agendarTransporteJornada && this.model.veiculoId
        },
        handleVeiculo() {

            this.getJornadas()

            this.model.jornadaId = null

            if (this.model.veiculoId !== null) {

                const veiculo = this.veiculos.find(v => v.id === this.model.veiculoId)

                this.model.capacidade = veiculo.capacidade
                this.model.totalAgendados = veiculo.agendados ? veiculo.agendados.quantidade : 0
                this.model.tipoVeiculoId = veiculo.tipoId
            } else {

                this.resetAtribuir()
            }
        },
        getJornadas() {

            this.setLoading()

            const dataSaida = this.model.dataSaida

            this.repositories.escolher.getJornadas({
                'veiculo_id': this.model.veiculoId,
                'data_saida': `${this.getFormatedDate(dataSaida, 'YYYY-MM-DD')}`,
            })
                .then(({ data }) => {

                    this.jornadas = data
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleJornada() {

            if (this.model.jornadaId) {

                const jornada = this.jornadas.find(jornada => jornada.id === this.model.jornadaId)

                this.model.capacidade = jornada.numeroCapacidade
                this.model.totalAgendados = jornada.totalAgendados
                this.model.tipoVeiculoId = jornada.tipoId

                if (!this.model.veiculoId) {

                    const veiculo = this.veiculos.find(v => v.id === jornada.veiculoId)

                    if (veiculo) {
                        this.model.veiculoId = jornada.veiculoId
                    }
                }
            } else {

                this.model.capacidade = null
                this.model.totalAgendados = null
                this.model.tipoVeiculoId = null

                const veiculo = this.veiculos.find(v => v.id === this.model.veiculoId)

                if (veiculo) {

                    this.model.capacidade = veiculo.capacidade
                    this.model.totalAgendados = veiculo.agendados ? veiculo.agendados.quantidade : 0
                    this.model.tipoVeiculoId = veiculo.tipoId
                }
            }
        },
        checkJornada(item) {

            let message = ''
            let existeJornada = false
            let exibirConfirmacao = false
            let agendamentosMesmoDia = []

            const agendamentos = this.agendamentosJornada.filter(a => a.pacienteId === item.pacienteId)

            if (this.form.agendarTransporteJornada) {

                const agendamentoMesmaJornada = agendamentos.find(a => a.jornadaId === this.model.jornadaId)

                if (agendamentoMesmaJornada) {

                    existeJornada = true

                    message = `<br/><br/>O paciente <strong>${agendamentoMesmaJornada.pacienteNome}</strong> já está agendado
                        nesta jornada (mesmo veículo e horário), portanto não é necessário cadastrá-lo novamente.`
                }
            }

            const dataHoraSaida = this.getFormatedDate(this.model.dataSaida, 'YYYY-MM-DD') + ' ' + item.horarioSaida

            if (dataHoraSaida && !existeJornada) {

                agendamentosMesmoDia = agendamentos.filter(a => a.dataInicial <= dataHoraSaida && a.dataFinal >= dataHoraSaida)

                if (agendamentosMesmoDia.length > 0) {

                    existeJornada = true
                    exibirConfirmacao = true
                }
            }

            return {
                message: message,
                existeJornada: existeJornada,
                exibirConfirmacao: exibirConfirmacao,
                agendamentosMesmoDia: agendamentosMesmoDia,
            }
        },
        handleBlur(){

            let selecionado = false

            this.items.map(item => {

                if (item.selecionado == true) {

                    selecionado = true
                }
            })

            if (selecionado) {

                this.selecionados = true
            } else {

                this.selecionados = false
            }
        },
        atribuir() {

            this.$refs.FormAtribuir.validate()
                .then(valid => {

                    if (!valid || !this.validateAtribuir()) return

                    let message = ''
                    let agendamentosMesmoDia = []

                    this.items.filter(i => !!i.selecionado).forEach(item => {

                        if (this.model.jornadaId) {

                            item.jornadaId = this.model.jornadaId
                        }

                        const checkJornada = this.checkJornada(item)

                        if (checkJornada.existeJornada) {

                            if (checkJornada.exibirConfirmacao) {

                                agendamentosMesmoDia.push({
                                    agendamentos: checkJornada.agendamentosMesmoDia,
                                    onConfirm: () => this.atribuirItem(item),
                                })
                            }
                            else {

                                message = message.concat(checkJornada.message)
                            }
                        }
                        else {

                            this.atribuirItem(item)
                        }
                    })

                    const finish = () => {

                        if (message) {

                            this.showAlert(`Não foi possível atribuir para o(s) seguinte(s) paciente(s): ${message}`)
                        }

                        this.resetAtribuir()
                    }

                    if (agendamentosMesmoDia.length > 0) {

                        this.$refs.ModalListaAgendamento.open(agendamentosMesmoDia, finish)

                        return
                    }

                    finish()
                })
        },
        atribuirItem(item) {

            item.veiculoId = this.model.veiculoId
            item.veiculoNome = this.veiculos.find(veiculo => veiculo.id === this.model.veiculoId).descricao
            item.supervisorId = this.model.supervisorId
            item.totalAgendados = this.getTotalAgendados
            item.capacidade = this.model.capacidade
        },
        save() {
            this.$refs.Table.validate()
                .then(valid => {
                    if(valid) {
                        this.setLoading()
                        this.repositories.escolher.store(this.camelObjectKeysToSnakeRecursive(this.items))
                            .then(() => {
                                this.showConfirmation(
                                    'Registro salvo com sucesso. Deseja ir para listagem de transportes agendados?',
                                    async () => {
                                        this.$nextTick().then(() => {
                                            this.unsetShowExitFormConfirmation()
                                            this.$router.push({ name: 'listagem-list'})
                                        })
                                    }
                                )
                                this.resetForm()
                            })
                            .catch(this.handleError)
                            .finally(() => this.unsetLoading())
                    }
                })
        },
        validateAtribuir() {

            if (this.jornadas && this.jornadas.length === 0 && this.form.agendarTransporteJornada) {

                this.showAlert('Informe uma data e horário de saída que tenha uma jornada associada.', 'Atenção')

                return false
            }

            const totalAgendados = Number(this.getTotalAgendados) + Number(this.getTotalSelecionado)

            if (this.model.veiculoId && totalAgendados > this.model.capacidade && this.model.supervisorId == null) {

                const msg = `Para continuar com a atribuição, é necessário que sejam informados os dados
                    do supervisor, uma vez que a quantidade de passageiros selecionados excede a capacidade máxima do veículo.
                    Deseja continuar?`

                this.showAlert(msg, 'Atenção')

                const confirm = async () => {

                    this.$refs.RkmModalPermissao.open()
                }

                this.showConfirmation(msg, confirm)

                return false
            }

            return true
        },
        handlePermission(supervisorId){

            this.model.supervisorId = supervisorId

            this.atribuir()
        },
        getTotal() {

            return this.items.reduce((sum, element) => {

                if (element.acompanhante !== 'NÃO') {

                    sum = sum + (Number(element.acompanhante) + 1);
                } else {

                    sum++;
                }

                return sum;
            },0)
        },
        resetAtribuir() {

            this.model.veiculoId = null
            this.model.jornadaId = null
            this.model.capacidade = null
            this.model.totalAgendados = null
            this.model.tipoVeiculoId = null
            this.model.supervisorId = null

            if (this.$refs.FormAtribuir) {

                this.$refs.FormAtribuir.resetValidator()
            }
        },
        cancelAtribuir(item) {

            const cancel = async () => {

                item.veiculoId = null
                item.veiculoNome = 'NÃO ATRIBUÍDO'
            }

            this.showDeleteConfirmation(`Deseja realmente cancelar a atribuição?`, cancel)
        },
        cancelAtribuirSelecionados() {

            const cancel = async () => this.items.filter(item => item.selecionado && item.veiculoId).map((item) => {

                item.veiculoId = null
                item.veiculoNome = 'NÃO ATRIBUÍDO'
            })

            this.showDeleteConfirmation(`Deseja realmente cancelar as atribuições selecionadas?`, cancel)
        },
        rowClass(item, type) {
            if (item && type === 'row') {
                if (item.tipoPassageiroId === this.enums.tipoPassageiro.ACAMADO) {
                    return 'table-warning'
                }
                else if (item.tipoPassageiroId === this.enums.tipoPassageiro.CADEIRANTE) {
                    return 'table-danger'
                }
                else if (item.consultaObservacao) {
                    return 'table-info'
                }
            }
        },
    },
    mixins: [ error, repository, object, data, stringCase ],
    watch: {
        'model.veiculoId': function (tipoVeiculo) {

            if (tipoVeiculo) {

                this.getJornadas()
                const veiculo = this.veiculos.find(v => v.id === this.model.veiculoId)

                if (veiculo) {
                    this.model.capacidade = veiculo.capacidade
                    this.model.totalAgendados = veiculo.agendados ? veiculo.agendados.quantidade : 0
                    this.model.tipoVeiculoId = veiculo.tipoId
                }
            } else {
                this.getJornadas()
            }
        },
    }
};
</script>

<style scoped>
.dataSaida { width:150px }
.table-td {
    background: #f1f1f1;
    padding: 0 10px;
    height: 35px;
    line-height: 35px;
    font-weight: 600;
}
</style>